import { Injectable } from "@angular/core";
import { RoleName } from "../classes/flow/session/Session";
import { BaseAuthService } from "../ffwd/services/base-auth.service";
import { SessionResponse, SessionRole } from "../ffwd/types/session.types";
import { ENVIRONMENT } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthService extends BaseAuthService {
  public roleName: RoleName;
  public specialties: number[];
  public coachId: number | null;

  constructor() {
    super();
    this.roleName = "guest";
    this.VIEW = ENVIRONMENT.DEFAULT_LOGIN_VIEW !== undefined ? ENVIRONMENT.DEFAULT_LOGIN_VIEW : "email";
    this.specialties = [];
    this.coachId = null;

    this.session.subscribe((value) => {
      if (this.isCoach()) this.roleName = "coach";
      if (this.isCoordinator()) this.roleName = "coordinator";
      if (this.isResident()) this.roleName = "resident";
      if (!value) this.roleName = "guest";

      let extrajson: Record<string, unknown> = {};
      if (typeof value?.session.extrajson === "object" && value.session.extrajson !== null) extrajson = value.session.extrajson;

      if (typeof value?.session.extrajson === "string" && value.session.extrajson) {
        try {
          extrajson = JSON.parse(value.session.extrajson);
        } catch (error) {
          console.log("Unable to parse extrajson");
        }
      }

      const specialties = extrajson?.omlSpecialties;
      if (typeof specialties === "string") {
        this.specialties = specialties
          .split(",")
          .map((x) => parseInt(x))
          .filter((x) => !isNaN(x));
        console.log("Settings specialties =>", this.specialties);
      }
      const coachId = extrajson?.idgCoachID;
      if (coachId && typeof coachId === "number") {
        this.coachId = coachId;
      } else {
        this.coachId = null;
      }
    });
  }

  protected override async update(session: SessionResponse | null): Promise<void> {
    super.update(session);
    if (session && !this.isCoordinator(session?.role) && !this.isCoach(session?.role) && !this.isResident(session?.role)) {
      // Switch
      console.log("Uknown role..");
      let role: SessionRole | null = this.findRoleInWorkspace(session.workspaces.find((x) => x.id === session?.workspace.id)?.roles ?? []);
      if (!role) {
        for (const workspace of session.workspaces) {
          role = this.findRoleInWorkspace(workspace.roles ?? []);
          if (role) {
            console.log("Changing workspace..", workspace);
            const _updatedWorkspaceSession = await this.changeWorkspace(workspace);
            return this.update(_updatedWorkspaceSession);
          }
        }
      } else {
        console.log("Changing role..", role);
        const _updatedRoleSession = await this.changeRole(role);
        return this.update(_updatedRoleSession);
      }
    }
  }

  public isCoach(role?: SessionRole) {
    const _role = role ?? this.session.value?.role;
    return !!(_role?.id == RoleId.COACH);
  }

  public isCoordinator(role?: SessionRole) {
    const _role = role ?? this.session.value?.role;
    return !!(_role?.id == RoleId.COORDINATOR);
  }

  public isResident(role?: SessionRole) {
    const _role = role ?? this.session.value?.role;
    return !!(_role?.id == RoleId.RESIDENT);
  }

  private findRole(id: string, roles: SessionRole[]): SessionRole | null {
    return roles.find((x) => x.id === id) ?? null;
  }

  private findRoleInWorkspace(roles: SessionRole[]): SessionRole | null {
    let role: SessionRole | null = this.findRole(RoleId.COORDINATOR, roles);
    if (!role) role = this.findRole(RoleId.COACH, roles);
    if (!role) role = this.findRole(RoleId.RESIDENT, roles);
    return role;
  }
}

enum RoleId {
  COORDINATOR = "112",
  RESIDENT = "110",
  COACH = "108",
}
